import React from 'react';

type Action = { label: string; onClick: () => void };

type Props = {
  message?: string;
  variant?: 'empty' | 'noMatch' | 'filtered' | 'error';
  title?: string;
  subtitle?: string;
  actions?: Action[];
};

const EmptyState: React.FC<Props> = ({
  message,
  variant = 'empty',
  title,
  subtitle,
  actions = [],
}) => {
  const heading =
    title ??
    (variant === 'error'
      ? '데이터를 불러오지 못했습니다'
      : variant === 'noMatch' || variant === 'filtered'
      ? '조건에 맞는 항목이 없습니다'
      : '표시할 항목이 없습니다');

  const desc = subtitle ?? message ?? '';

  return (
    <div
      className="empty-wrap"
      style={{
        textAlign: 'center',
        padding: 24,
        borderRadius: 12,
        border: '1px solid rgba(120,140,180,0.18)',
        background: 'rgba(12,20,34,0.7)',
        color: '#9fb4d8',
      }}
    >
      <div style={{ fontWeight: 900, color: '#eaf2ff', marginBottom: 6 }}>
        {heading}
      </div>

      {desc && <div style={{ marginBottom: 12 }}>{desc}</div>}

      {!!actions.length && (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          {actions.map((a, i) => (
            <button
              key={i}
              onClick={a.onClick}
              style={{
                background: 'rgba(51,132,255,0.1)',
                border: '1px solid rgba(51,132,255,0.35)',
                borderRadius: 8,
                padding: '6px 10px',
                color: '#7fb1ff',
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmptyState;